import { useState, useMemo } from 'react'

import {
	EuiFieldSearch,
	EuiProgress,
} from '@equipmentshare/ds2'

import InventoryLocationsSelectable from 'views/components/InventoryLocationsSelectable'
import useInventoryLocationsSearch, { groupInventoryLocationsByBranch } from 'hooks/inventory-location-search'
import useInputDebounce from 'hooks/useInputDebounce'
import { SelectedInventoryLocation } from '../../helpers/downloadHelpers'

export type MultiInventoryLocationsPickerProps = {
	selectedIds: string[],
	setSelectedIds: ( ids: string[] ) => void,
	setSelectedInventoryLocations: ( items: SelectedInventoryLocation[] ) => void,
	height?: string,
	isLoading?: boolean,
}

export const DEBOUNCE_DELAY_MS = 300

export default function MultiInventoryLocationsPicker( { selectedIds, setSelectedIds, setSelectedInventoryLocations, height, isLoading }: MultiInventoryLocationsPickerProps ) {
	const [ inputVal, setInputVal ] = useState( '' )
	const [ search, setSearch ] = useState( '' )

	const { loading, filteredInventoryLocations } = useInventoryLocationsSearch( search, 'inventory-locations-filter', 'no-cache', undefined, undefined, true )

	useInputDebounce( inputVal, DEBOUNCE_DELAY_MS, ( debouncedInputValue ) => setSearch( debouncedInputValue ) )
	const onInputChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setInputVal( event.currentTarget.value )

	const branches = useMemo( () => groupInventoryLocationsByBranch( filteredInventoryLocations ), [ filteredInventoryLocations ] )
	return (
		<>
			{ ( loading || isLoading ) && <EuiProgress size="xs" /> }
			<EuiFieldSearch
				onChange={onInputChange}
				value={inputVal}
			/>
			<InventoryLocationsSelectable
				style={{ height: height ?? '40vh' }}
				isLoading={loading || isLoading}
				branches={branches}
				selectedIds={selectedIds}
				setSelectedIds={setSelectedIds}
				setSelectedItems={setSelectedInventoryLocations}
			/>
		</>
	)
}
